// @ts-strict-ignore
import React, { useContext } from 'react';
import {
  Box,
  Tooltip,
  Text,
} from '@usealloy/component-library';

import { UserContext } from '~/dashboard/context';
import { routes } from '~/helpers/routes';
import { ValidationTextField, RestoreLink, StyledValidationLink } from './styles';
import { DefaultLevel } from './types';

interface ServiceConfigValidationProps {
  isUsingDefault: boolean;
  defaultLevel: string;
  hasError: boolean;
  errorMessage: string;
  restoreFn: () => void;
  defaultValueMessage: string;
  serviceId: number;
  isOwner: boolean;
  isReadOnly?: boolean;
}

export const ServiceConfigValidation = ({
  isUsingDefault,
  defaultLevel,
  hasError,
  errorMessage,
  restoreFn,
  defaultValueMessage,
  serviceId,
  isOwner,
  isReadOnly,
}: ServiceConfigValidationProps) => {
  const { customer: { organizationName }, agent: { isAgent } } = useContext(UserContext);
  const defaultName = defaultLevel === 'customer' ? organizationName : defaultLevel;
  const isAlloyDefaultLevel = defaultLevel === DefaultLevel.ALLOY;

  return (
    <Box justifyContent="flex-start">
      {(isUsingDefault && !hasError) ? (
        <Tooltip
          content={defaultLevel === 'customer' ? (
            <Text style={{ color: 'white', fontSize: 'var(--cl-font-size-1)' }}>
              {organizationName} has set this configuration as default.
              To view go to
              <StyledValidationLink
                to={{
                  pathname: routes.v3.dashboard.settings.services,
                  hash: `${serviceId}`,
                }}
                target="_blank"
              >
                Service Settings
              </StyledValidationLink>
            </Text>
          ) : (
            <Text style={{ color: 'white', fontSize: 12 }}>
              This configuration has been set by default at the Alloy level.
            </Text>
          )}
          align="center"
          style={{ fontSize: 12, width: 185, textAlign: 'center' }}
          side="bottom"
        >
          <ValidationTextField>Using {defaultName} Default</ValidationTextField>
        </Tooltip>
      ) : (
        <Box justifyContent="flex-start">
          <Box justifyContent="flex-start">
            <ValidationTextField style={hasError ? { color: 'var(--cl-background-danger)' } : {}}>
              { hasError && (<span>{errorMessage}</span>)}
              {
                // customer agent don't have permission to view the alloy level default owner field
                (defaultValueMessage && !(isAgent && isOwner && isAlloyDefaultLevel)) && (
                  <span style={{ textTransform: 'capitalize' }}>
                    &nbsp;{defaultName} Default: {defaultValueMessage}
                  </span>
                )
              }

            </ValidationTextField>
          </Box>
          {
            // customer agent don't have permission to restore owner filet to alloy level
            (!isReadOnly && defaultValueMessage && !(isAgent && isOwner && isAlloyDefaultLevel))
            && (
              <Box
                justifyContent="flex-end"
                style={{ width: '30%' }}
              >
                <RestoreLink
                  onClick={restoreFn}
                  role="button"
                  tabIndex={0}
                >
                  restore default
                </RestoreLink>
              </Box>
            )
          }

        </Box>
      )}
    </Box>
  );
};
